
import { ComparisonDimension } from "./types/comparison";

export const COMPARISON_DIMENSIONS: ComparisonDimension[] = [
  'sbu', 
  'gender', 
  'location', 
  'employment_type',
  'level',
  'employee_type',
  'employee_role',
  'supervisor',
  'generation'
];
